// Progres tontonan: posisi terakhir tiap video, supaya bisa "Lanjut dari
// 12:34" dan muncul di baris "Lanjutkan menonton". Disimpan di bot (ikut
// terbawa antar perangkat: nonton di HP, lanjut di PC) dan di localStorage
// perangkat ini sebagai cadangan kalau bot tidak bisa dihubungi.
//
// Kunci tiap video = identitas chunk-nya (fileKeyOf), jadi tetap cocok
// walau file di-rename atau dipindah folder.
// Di halaman publik (/nonton) progres hanya disimpan di perangkat penonton.
import { botJson, isPublicMode } from './api.js';

const MAX_LOCAL = 300;
let items = {};
let loadedFor = null;
const lastSent = new Map();

function localKey(userId) {
    return `disbox_${userId}_progress`;
}

function readLocal(userId) {
    try {
        return JSON.parse(localStorage.getItem(localKey(userId))) || {};
    } catch {
        return {};
    }
}

function writeLocal(userId) {
    try {
        const keys = Object.keys(items);
        if (keys.length > MAX_LOCAL) {
            keys.sort((a, b) => items[a].updatedAt - items[b].updatedAt);
            for (const key of keys.slice(0, keys.length - MAX_LOCAL)) delete items[key];
        }
        localStorage.setItem(localKey(userId), JSON.stringify(items));
    } catch {
        // localStorage penuh: progres tetap ada di bot.
    }
}

export async function loadProgress(userId) {
    loadedFor = userId;
    items = readLocal(userId);
    if (isPublicMode()) return items;
    try {
        const data = await botJson(`/progress/${userId}`);
        for (const [key, remote] of Object.entries(data.items || {})) {
            if (!items[key] || (remote.updatedAt || 0) > (items[key].updatedAt || 0)) items[key] = remote;
        }
        writeLocal(userId);
    } catch {
        // Bot tidak bisa dihubungi: pakai catatan lokal saja.
    }
    return items;
}

export function getProgress(key) {
    return key ? items[key] || null : null;
}

// entry: { key, path, name, position, duration, finished }
export function saveProgress(userId, entry, { force = false } = {}) {
    if (!entry || !entry.key || loadedFor !== userId) return;
    items[entry.key] = { ...entry, updatedAt: Date.now() };
    writeLocal(userId);
    if (isPublicMode()) return;
    const last = lastSent.get(entry.key) || 0;
    if (!force && Date.now() - last < 15000) return;
    lastSent.set(entry.key, Date.now());
    botJson(`/progress/${userId}`, { method: 'PUT', json: entry }).catch(() => {});
}

export function removeProgress(userId, key) {
    delete items[key];
    writeLocal(userId);
    if (isPublicMode()) return;
    botJson(`/progress/${userId}`, { method: 'PUT', json: { key, remove: true } }).catch(() => {});
}

// Video yang sedang ditonton (belum selesai), terbaru dulu.
export function getContinueWatching(limit = 12) {
    return Object.values(items)
        .filter((item) => !item.finished && item.position > 20 && (!item.duration || item.position < item.duration - 30))
        .sort((a, b) => b.updatedAt - a.updatedAt)
        .slice(0, limit);
}

export function formatTime(seconds) {
    const total = Math.max(0, Math.floor(seconds || 0));
    const h = Math.floor(total / 3600);
    const m = Math.floor((total % 3600) / 60);
    const s = total % 60;
    return h > 0 ? `${h}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}` : `${m}:${String(s).padStart(2, '0')}`;
}
